import useReactHookForm from "hooks/useReactHookForm";

import { useAppDispatch } from "hooks/redux";
import { Button, Grid, Paper } from "@mui/material";
import DynamicForm from "shared/organisms/dynamicform";
import ContentRight from "shared/molecules/content-right";
import { examScheduleInitialValuesFilter, examSchedulePropertiesFilter, examScheduleValidationSchemaFilter } from "./helper";
import { hasLengthGreaterThanZero, hasValidValue } from "pages/entities/helper";
import { useEffect } from "react";

export const ScheduleFilter = ({ setSearchPayload, setPage }) => {
  const { control, errors, getValues, watch, setValue } = useReactHookForm(
    examScheduleInitialValuesFilter,
    examScheduleValidationSchemaFilter,
    ""
  );
  const dispatch = useAppDispatch();

  const clearFilter = () => {
    setValue("college_ids", []);
    setValue("class_ids", "");
    setValue("start_date", "");
    setValue("scheduled_exam_type_id", "");
    setValue("scheduled_exam_name", "");
    setSearchPayload({});
    setPage(1);
  };
  const handleSearch = () => {
    const payload = {
      branch_ids: watch()?.college_ids,
      class_ids: watch()?.class_ids,
      exam_type_id: watch()?.scheduled_exam_type_id,
      exam_name: watch()?.scheduled_exam_name,
      scheduled_date: watch()?.start_date
    };
    setSearchPayload(payload);
    setPage(1);
  };

  return (
    <div>
      <Paper elevation={2} sx={{ px: 2, pb: 2 }}>
        <Grid container spacing={2}>
          <DynamicForm
            fields={examSchedulePropertiesFilter}
            control={control}
            errors={errors}
            getValues={getValues}
            setValue={setValue}
            watch={watch}
          />
          <ContentRight sx={{ mt: -7 }}>
            <Button
              variant="contained"
              sx={{
                width: "70px",
                height: "40px",
                marginTop: "15px",
                marginRight: "10px",
                padding: "7px 42.5px 7px 48.5px",
                cursor: "pointer",
                textAlign: "center",
              }}
              onClick={clearFilter}
              disabled={!shouldEnableButton(watch())}
            >
              clear
            </Button>
            <Button
              variant="contained"
              sx={{
                width: "80px",
                height: "40px",
                marginTop: "15px",
                padding: "7px 42.5px 7px 48.5px",
                cursor: "pointer",
                textAlign: "center",
              }}
              onClick={handleSearch}
              disabled={!shouldEnableButton(watch())}
            >
              search
            </Button>
          </ContentRight>
        </Grid>
      </Paper>
    </div>
  );
};

function shouldEnableButton(obj: Record<string, any>): boolean {
  return Object.values(obj).some((val) => {
    if (typeof val === "string" && val.trim() !== "") return true;   // non-empty string
    if (Array.isArray(val) && val.length > 0) return true;           // non-empty array
    if (val instanceof Date && !isNaN(val.getTime())) return true;   // valid Date
    if (typeof val === "number" && val > 0) return true;             // positive number
    return false;
  });
}



